import { render, staticRenderFns } from "./addNewAdviceDialog.vue?vue&type=template&id=d37f9e8e"
import script from "./addNewAdviceDialog.vue?vue&type=script&lang=js"
export * from "./addNewAdviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports